const BASE_URL = 'https://www.dnd5eapi.co/api/';

const endpoints = {
    spells: `${BASE_URL}/spells`,
    spell: (spellIndex: string) => `${BASE_URL}/spells/${spellIndex}`
}

export default endpoints